import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Logo } from '@rossum/ui';
import { Box, Stack, Typography } from '@rossum/ui/material';
import { organizationBranding } from '../../../features/client-config/organization/branding';
import { safeOrganizationSelector } from '../../../redux/modules/organization/selectors';
import { State } from '../../../types/state';

type EmphasizedProps = { children: ReactNode };
const Emphasized = ({ children }: EmphasizedProps) => {
  return (
    <Box
      component="span"
      sx={{ fontWeight: 'bold', color: theme => theme.palette.text.primary }}
    >
      {children}
    </Box>
  );
};

const shouldRenderResolver = (state: State) => {
  const organization = safeOrganizationSelector(state);
  if (!organization) {
    return false;
  }

  return organizationBranding.displayRossumBranding(organization.uiSettings);
};

const PoweredBy = () => {
  const shouldRender = useSelector(shouldRenderResolver);
  const intl = useIntl();

  return shouldRender ? (
    <Stack direction="row" alignItems="center" gap={1}>
      <Logo size={14} />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {intl.formatMessage(
          {
            id: 'components.poweredBy.poweredByRossumHighlighted',
          },
          {
            white: (msg: ReactNode) => <Emphasized>{msg}</Emphasized>,
          }
        )}
      </Typography>
    </Stack>
  ) : null;
};

export default PoweredBy;
